<template>
  <el-card class="h-full">
    <div class="w-full h-full">
      <div class="flex flex-wrap mb-10px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="评价项目"
          maxlength="50"
          v-model="searchData.project"
          clearable
        ></el-input>

        <el-button size="small" type="primary" @click="searchList()">搜索</el-button>
        <el-button size="small" @click="resetSearch()">重置</el-button>
        <el-button
          size="small"
          type="primary"
          @click="handleEvent(null, 'create')"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button
          size="small"
          type="danger"
          @click="handleEvent(null, 'batchDelete')"
          :disabled="!$hasAccess('delete')"
          >删除</el-button
        >
        <el-button
          size="small"
          @click="handleEvent(null, 'batchImport')"
          :disabled="!$hasAccess('batchImport')"
          >导入</el-button
        >
        <el-button
          size="small"
          @click="handleEvent(null, 'batchExport')"
          :disabled="!$hasAccess('batchExport')"
          >导出</el-button
        >
      </div>
      <el-table
        :data="tableList"
        border
        class="w-full custome-table"
        :height="tableHeight"
        stripe
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="评价项目" prop="project" width="180"></el-table-column>
        <el-table-column
          label="评价内容"
          width="480"
          height="auto"
          prop="content"
        ></el-table-column>
        <el-table-column label="标准分" width="180" prop="standardScore"></el-table-column>
        <el-table-column label="评分标准" width="480" prop="scoringStandar"></el-table-column>

        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              :disabled="!$hasAccess('read')"
              @click="handleEvent(scope.row, 'read')"
              >查看</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('update')"
              @click="handleEvent(scope.row, 'update')"
              >编辑</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('delete')"
              @click="handleEvent(scope.row, 'delete')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
      <wiz-upload-file
        v-dialogDrag
        :uploadFileProps="uploadFileProps"
        @exportTemplate="exportTemplate"
        @importTemplate="importTemplate"
        @exportResults="exportResults"
      ></wiz-upload-file>
    </div>
  </el-card>
</template>
<script>
import { download } from '@/assets/js/CommonDownload'
import { FileApi } from '@wiz-api/file-management'
import { SafetyEvaluationApi } from '@wiz-api/safety-evaluation-management'

const safetyEvaluationApi = new SafetyEvaluationApi()
const fileApi = new FileApi()
export default {
  components: {},
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xlsx', 'xls'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      selectionData: [],
      loading: false,
      searchData: {
        project: '',
      },
      total: 0,
      pageNo: 1,
      pageSize: 15,
      tableList: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 108px)'
    },
    routerBase() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  async created() {
    await this.findList()
  },
  methods: {
    // 下载模板
    async exportTemplate() {
      const [err, res] = await safetyEvaluationApi.downloadToExcelTemplateFile()
      if (!err) {
        download('安全评价.xlsx', res, 'application/octet-stream')
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      const [err, res] = await safetyEvaluationApi.importToExcel({
        file: formData.get('file'),
      })
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.searchList()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    async exportResults() {
      const [err, res] = await fileApi.download(this.uploadFileProps.resultFile, {
        returnType: 'Blob',
      })
      if (!err) {
        download(
          '导入结果.xlsx',
          res,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
      }
    },
    handleSelectionChange(values) {
      this.selectionData = values.map((item) => {
        return item.id
      })
    },
    resetSearch() {
      this.searchData = this.$options.data()
      this.searchList()
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    async findList() {
      this.loading = true
      const [err, res] = await safetyEvaluationApi.getPgeList({
        project: this.searchData.project,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
      })
      this.loading = false
      if (!err) {
        this.tableList = res.items
        this.total = res.totalCount
      }
    },
    async exportConetnt() {
      // if (this.selectionData.length === 0) {
      //   this.$message.error('请选择要导出的记录')
      //   return
      // }
      const [err, res] = await safetyEvaluationApi.exportToExcelFile({
        body: {
          ids: this.selectionData,
        },
      })

      if (!err) {
        download('安全评价.xlsx', res, 'application/octet-stream')
        this.$message({
          showClose: true,
          message: '导出成功',
          type: 'success',
        })
      }
    },
    handleEvent(row, type) {
      switch (type) {
        case 'create':
          this.$router.push({
            path: `${this.routerBase}/safety-evaluation/info`,
            query: {
              type: 'create',
            },
          })
          break
        case 'read':
          this.$router.push({
            path: `${this.routerBase}/safety-evaluation/info`,
            query: {
              id: row.id,
              type: 'read',
            },
          })
          break
        case 'update':
          this.$router.push({
            path: `${this.routerBase}/safety-evaluation/info`,
            query: {
              id: row.id,
              type: 'update',
            },
          })
          break
        case 'batchDelete':
          this.$confirm('是否删除已勾选记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await safetyEvaluationApi.deleteMany({
                body: this.selectionData,
              })
              if (!err) {
                this.$message.success('删除成功')
                this.searchList()
              }
            })
            .catch(() => {})
          break
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await safetyEvaluationApi.callDelete(row.id)
              if (!err) {
                this.$message.success('删除成功')
                this.searchList()
              }
            })
            .catch(() => {})
          break
        case 'batchExport':
          this.exportConetnt()
          break
        case 'batchImport':
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        default:
          break
      }
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-table__body .el-table__row .cell {
  padding: 10px 0;
  height: 100px;
  overflow: scroll;
}
</style>
